"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductsTableConfig = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const constants_1 = require("./constants");
const use_column_filter_config_hook_1 = require("./use-column-filter-config.hook");
const use_products_table_columns_config_hook_1 = require("./use-products-table-columns-config.hook");
const cells_1 = require("../cells");
const use_get_attributes_as_columns_1 = require("../client/use-get-attributes-as-columns");
const product_table_1 = require("../../../../../common/product-table");
const table_columns_1 = require("../../../../../common/table-columns");
const attributes_1 = require("../../../../../constants/attributes");
const product_table_dynamic_columns_1 = require("../../../../../hooks/product-table-dynamic-columns");
const products_table_1 = require("../../../../../store/catalogs/products-table");
const localization_1 = require("../../../../../../localization");
const store_1 = require("../../../../../../store");
const getCellValues = (row, pathPrefix, label) => { var _a, _b; return ((_b = (_a = row[pathPrefix]) === null || _a === void 0 ? void 0 : _a[label]) !== null && _b !== void 0 ? _b : []); };
const useProductsTableConfig = (props) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { onActiveProductIdChange, isCellLoading = () => false, isCellSynced = () => false, isCellFailed = () => false, isRowDisabled, isCellAutoOpen, onCellSubmit, } = props || {};
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const productTreeNodeId = (0, store_1.useSelectedTreeNodeId)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const getColumnFilterConfig = (0, use_column_filter_config_hook_1.useColumnFilterConfig)(productTreeNodeId);
    const isAttributeNotInStrategy = (0, react_1.useCallback)((tags = []) => (tags.includes(attributes_1.SpecialAttributeValue.NotInStrategy)), []);
    // Block cell editing while reclassification is in progress
    const isCellEditable = (0, react_1.useCallback)((params) => (!isAttributeNotInStrategy(params.value)), [isAttributeNotInStrategy]);
    const rowSize = (0, products_table_1.useProductsTableRowSize)();
    const productsTableColumnsConfig = (0, use_products_table_columns_config_hook_1.useProductsTableColumnsConfig)({
        onActiveProductIdChange,
        rowSize,
        isCellLoading,
    });
    const persistedColumnsData = (0, products_table_1.useProductsTableDynamicColumns)();
    const updateGlobalState = (0, react_1.useCallback)((newData) => dispatch((0, products_table_1.setProductsDynamicTableColumns)(catalogId, newData)), [dispatch, catalogId]);
    const { excludedColumns, excludedLabelColumns, excludedMeasureColumns, columnsOrder, filterOptions, selectAllMode, checkIsColumnSelected, actions, } = (0, product_table_dynamic_columns_1.useCustomizeTableColumns)({
        options: {
            persistedTableData: persistedColumnsData,
            setPersistedTableData: updateGlobalState,
        },
    });
    const productAttributeFilter = (0, react_1.useMemo)(() => {
        if (!excludedLabelColumns.length && selectAllMode) {
            return null;
        }
        let newExcludedLabelColumns = [];
        // base fields should be always displayed
        if (selectAllMode) {
            newExcludedLabelColumns = (0, ramda_1.without)(attributes_1.BASE_ENRICHED_ATTRIBUTES, excludedLabelColumns);
        }
        else {
            newExcludedLabelColumns = (0, ramda_1.uniq)([
                ...excludedLabelColumns,
                ...attributes_1.BASE_ENRICHED_ATTRIBUTES,
            ]);
        }
        const attributesFilter = !selectAllMode
            ? { in: newExcludedLabelColumns }
            : { notIn: newExcludedLabelColumns };
        return { label: attributesFilter };
    }, [excludedLabelColumns, selectAllMode]);
    const productMeasureFilter = (0, react_1.useMemo)(() => {
        if (!excludedMeasureColumns.length) {
            return null;
        }
        const attributesFilter = !selectAllMode
            ? { in: excludedMeasureColumns }
            : { notIn: excludedMeasureColumns };
        return { some: { dimension: attributesFilter } };
    }, [excludedMeasureColumns, selectAllMode]);
    const { isLoading, error, attributes } = (0, use_get_attributes_as_columns_1.useGetAttributesAsColumns)({
        catalogId,
        productTreeNodeId,
        productAttributeFilter,
        productMeasureFilter,
        filterOptions,
    });
    const createColumn = (0, react_1.useCallback)((attributeColumn, columnConfig, attributeId, dataMeta, isAttributeEditable, pathPrefix) => {
        const { id, label } = attributeColumn;
        const { isAIEnriched, isMeasure } = dataMeta;
        if (columnConfig) {
            return columnConfig;
        }
        const baseColumn = Object.assign({ headerName: label, renderHeader: (0, product_table_1.getColumnHeader)(id), field: id, valueGetter: (_, row) => getCellValues(row, pathPrefix, label), width: 240, minWidth: 48, resizable: true, editable: isAttributeEditable && !isMeasure }, getColumnFilterConfig(id));
        // Handle original attribute columns with date/array formatting
        const isOriginalAttributeColumn = pathPrefix === 'labels'
            && !isAIEnriched
            && !isMeasure;
        if (isOriginalAttributeColumn) {
            return Object.assign(Object.assign({}, baseColumn), { valueGetter: (_, row) => getCellValues(row, pathPrefix, label), valueFormatter: product_table_1.formatOriginalCellValue });
        }
        return Object.assign(Object.assign({}, baseColumn), (!isAIEnriched && !isMeasure ? ({}) : ({
            // Use custom AttributeTagsViewCell for view mode with Unknown styling
            valueFormatter: (params) => {
                if (!params || params.length === 0) {
                    return [];
                }
                // Convert values to labels using options
                const labels = params.map((tagValue) => {
                    if (tagValue === attributes_1.SpecialAttributeValue.NotInStrategy) {
                        return null;
                    }
                    if (tagValue === attributes_1.SpecialAttributeValue.NotApplicable) {
                        return t({ key: attributes_1.SpecialAttributeValueToLocalizationKey[attributes_1.SpecialAttributeValue.NotApplicable] });
                    }
                    return tagValue;
                }).filter((tagValue) => !!tagValue);
                return labels;
            },
            renderCell: (params) => { var _a; return (react_1.default.createElement(cells_1.AttributeTagsViewCell, { tags: params.formattedValue || [], disabled: ((_a = isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled(params.row)) !== null && _a !== void 0 ? _a : false), isSyncing: isCellLoading({ id: params.id, field: params.field }), isSynced: isCellSynced({ id: params.id, field: params.field }), isFailed: isCellFailed({ id: params.id, field: params.field }) })); },
            cellClassName: (params) => (isAttributeNotInStrategy(params.value) ? 'disabled-cell' : undefined),
            renderEditCell: (params) => { var _a; return (react_1.default.createElement(cells_1.AttributeTagsEditCell, { cellId: params.id, fieldName: params.field, value: params.formattedValue || [], row: params.row, attributeLabel: attributeId, productTreeNodeId: productTreeNodeId, autoOpen: (_a = isCellAutoOpen === null || isCellAutoOpen === void 0 ? void 0 : isCellAutoOpen(params.id, params.field)) !== null && _a !== void 0 ? _a : true, onSubmit: () => onCellSubmit === null || onCellSubmit === void 0 ? void 0 : onCellSubmit(params.id, params.field) })); },
        })));
    }, [
        getColumnFilterConfig,
        isAttributeNotInStrategy,
        isCellLoading,
        isCellSynced,
        isCellFailed,
        isRowDisabled,
        t,
        productTreeNodeId,
        isCellAutoOpen,
        onCellSubmit,
    ]);
    const columns = (0, react_1.useMemo)(() => {
        const customColumns = constants_1.CUSTOM_PRODUCT_FIELDS.map((label) => ({
            id: (0, table_columns_1.createColumnId)(label, label === attributes_1.CustomProductAttributes.ClassificationProductType
                ? { isAIEnriched: true }
                : undefined),
            label,
        }));
        const tableColumns = [];
        attributes.concat(customColumns).forEach((attributeColumn) => {
            var _a;
            const { id, isEditable } = attributeColumn;
            if (table_columns_1.BASE_COLUMNS.includes(id) || checkIsColumnSelected(id)) {
                const { label: attributeId, dataMeta } = (_a = (0, table_columns_1.parseColumnId)(id)) !== null && _a !== void 0 ? _a : {};
                const { isMeasure } = dataMeta;
                const columnConfig = productsTableColumnsConfig.find((columnConfig) => columnConfig.field === id);
                const isAttributeEditable = isEditable || (columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.editable);
                const pathPrefix = isMeasure ? product_table_1.MEASURE_PATH : product_table_1.LABEL_PATH;
                const column = createColumn(attributeColumn, columnConfig, attributeId, dataMeta, isAttributeEditable, pathPrefix);
                tableColumns.push(column);
            }
        });
        return tableColumns;
    }, [
        attributes,
        checkIsColumnSelected,
        createColumn,
        productsTableColumnsConfig,
    ]);
    const orderedColumns = (0, react_1.useMemo)(() => {
        const columnMap = new Map(columns.map((column) => [column.field, column]));
        return columnsOrder
            .map((id) => columnMap.get(id))
            .filter((column) => Boolean(column));
    }, [columns, columnsOrder]);
    return {
        tableColumns: {
            columns: orderedColumns,
            isLoading,
            error: error === null || error === void 0 ? void 0 : error.message,
            actions: {
                onChangeColumns: actions.onChangeColumns,
                setOrder: actions.setOrder,
            },
            selection: {
                excludedColumns,
                excludedLabelColumns,
                excludedMeasureColumns,
                selectAllMode,
                filterOptions,
            },
            order: {
                columnsOrder,
            },
            isCellEditable,
        },
    };
};
exports.useProductsTableConfig = useProductsTableConfig;
exports.default = exports.useProductsTableConfig;
